import '@coreui/coreui-pro/dist/css/coreui.min.css';
import React, { Component, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import 'rsuite/dist/rsuite.min.css';
import './global/fonts/fonts.css';
import './styles/index.scss';

const loading = (
    <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
);

// Containers
const Layout = React.lazy(() => import('./containers/Layout'));
const LoginPage = React.lazy(() => import('./containers/LoginPage'));
const ForgotPasswordPage = React.lazy(
    () => import('./containers/ForgotPasswordPage')
);
const ResetPasswordPage = React.lazy(
    () => import('./containers/ResetPasswordPage')
);
const ConfirmUserPage = React.lazy(
    () => import('./containers/ConfirmUserPage')
);

function App() {
    return (
        <Suspense>
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route
                    path="/forgotPassword"
                    element={<ForgotPasswordPage />}
                />
                <Route path="/resetPassword" element={<ResetPasswordPage />} />
                <Route path="/confirmUser" element={<ConfirmUserPage />} />

                <Route path="*" element={<Layout />} />
            </Routes>
        </Suspense>
    );
}

export default App;
